import "./App.css";
import Body from "./components/body/Body";
import Form from "./components/Form/Form";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Detail from "./components/Detail/Detail";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/activity" element={<Form />} />
        <Route path="/detail">
          <Route path=":id" element={<Detail />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
